import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconExternalSlack';
/** Renders an SVG icon. */
const SvgExternalSlack = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M9.06 19.172a2.52 2.52 0 0 1-2.52 2.522 2.52 2.52 0 0 1-2.52-2.522 2.52 2.52 0 0 1 2.52-2.522h2.52zm1.26 0a2.52 2.52 0 0 1 2.521-2.522 2.52 2.52 0 0 1 2.52 2.522v6.306A2.52 2.52 0 0 1 12.841 28a2.52 2.52 0 0 1-2.52-2.522zm2.52-10.127a2.52 2.52 0 0 1-2.52-2.523A2.52 2.52 0 0 1 12.84 4a2.52 2.52 0 0 1 2.52 2.522v2.523zm0 1.28a2.52 2.52 0 0 1 2.52 2.522 2.52 2.52 0 0 1-2.52 2.522H6.52A2.52 2.52 0 0 1 4 12.847a2.52 2.52 0 0 1 2.52-2.522zm10.1 2.522a2.52 2.52 0 0 1 2.52-2.522 2.52 2.52 0 0 1 2.52 2.522 2.52 2.52 0 0 1-2.52 2.522h-2.52zm-1.26 0a2.52 2.52 0 0 1-2.52 2.522 2.52 2.52 0 0 1-2.52-2.522V6.522A2.52 2.52 0 0 1 19.16 4a2.52 2.52 0 0 1 2.52 2.522zm-2.52 10.108a2.52 2.52 0 0 1 2.52 2.523A2.52 2.52 0 0 1 19.16 28a2.52 2.52 0 0 1-2.52-2.522v-2.523zm0-1.26a2.52 2.52 0 0 1-2.52-2.523 2.52 2.52 0 0 1 2.52-2.522h6.32A2.52 2.52 0 0 1 28 19.172a2.52 2.52 0 0 1-2.52 2.522h-6.32Z"
      />
    </svg>
  );
};
SvgExternalSlack.displayName = displayName;
export default SvgExternalSlack;
